import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { AppInjectorService } from 'src/app/app-injector.service';
import { AlertService } from '../crosscutting/alerts/alert.service';
import { ToastrService } from 'ngx-toastr';
import { ConfigurationService } from '../crosscutting/configuration/configuration.service';
import { IAppConfiguration } from '../crosscutting/configuration/i-configuration';
import { HttpService } from '../crosscutting/http-service/http.service';
import { LoggingService } from '../crosscutting/logging/logging.service';
import { StateObject } from '../models/state-object.model';
import { GlobalEventsService } from '../services/global-events.service';
import { StateService } from '../services/state.service';
import { NavigationService } from 'src/app/features-common/services/navigation.service';
import { RxStompService } from '@stomp/ng2-stompjs';
import { ConfigValuesService } from 'src/app/features-common/services/config-values.service';


@Component({
  template: '',
  styles: [
  ]
})
export class BaseComponent implements OnInit, OnDestroy {

  private componentLoadingCompleteSource = new Subject<void>();
  componentLoadingComplete = this.componentLoadingCompleteSource.asObservable();

  protected eventSubscriptions: Array<Subscription> = [];
  iappConfiguration: IAppConfiguration;
  configurationService: ConfigurationService;
  loggingService: LoggingService;
  globalEventsService: GlobalEventsService;
  alertService: AlertService;
  uiConfigValuesService: ConfigValuesService;
  toastrService: ToastrService;
  rxStompService: RxStompService
  navigationService: NavigationService;
  httpService: HttpService;
  stateService: StateService<StateObject>;
  alertSubscription;

  constructor() {
    const injector = AppInjectorService.getInstance().getInjector();
    this.configurationService = injector.get(ConfigurationService);
    this.iappConfiguration = this.configurationService.applicationConfiguration;
    this.loggingService = injector.get(LoggingService);
    this.globalEventsService = injector.get(GlobalEventsService);
    this.alertService = injector.get(AlertService);
    this.toastrService = injector.get(ToastrService);
    this.navigationService = injector.get(NavigationService);
    this.rxStompService = injector.get(RxStompService);
    this.httpService = injector.get(HttpService);
    this.stateService = injector.get(StateService);
    this.uiConfigValuesService = injector.get(ConfigValuesService);

    // const injector = AppInjectorService.getInstance().getInjector();
    const ngZone = injector.get(NgZone);


  }

  ngOnInit() {
    this.componentLoaded();
  }

  // This method is available for child components that do not call ngOnInit()
  // This allows unit test to know when to proceed
  protected setOnInitComplete() {
    this.componentLoadingCompleteSource.next();
  }

  protected componentLoaded() {
    this.globalEventsService.completeRouting();
  }

  private logNavigation() {
    // this.loggingService.logPageView(); // Use this option for manual control of page view logging
  }


  ngOnDestroy() {
    this.eventSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

}
